export const SCREENS_LIST = {
    projects: '/projects',
    news: '/news',
    contact: '/contact',
    info: '/info'
}
